import React from 'react'
import { Button, PageHeader } from '@pushly/aqe/lib/components'
import { AppService } from '../../services'
import { AppState } from '../../stores/app'
import { getPathEntityId } from '../../_utils/get-path-entity-id'
import { useService } from '@pushly/aqe/lib/hooks'
import { SubjectEntity } from '../../enums/ability-entity.enum'
import { AbilityAction } from '../../enums/ability-action.enum'
import { CurrentUserCan } from '../../stores/app-ability'
import SimpleTabbedView from '../../components/simple-tabbed-view/simple-tabbed-view'
import JourneyTableWell from '../journeys/journey-table-well/journey-table-well'

const Journeys = (props) => {
    const appState = useService(AppState)
    const appService = useService(AppService)

    const pathDomainId = getPathEntityId('domain')

    const listProps: any = { ...props }
    listProps.level = 'domain'
    listProps.domainId = pathDomainId

    const newJourneyPath = appService.routeWithinDomain('/journeys/new', true)

    const journeyTabs = [
        {
            tabClassName: 'journey-list-tab',
            component: SimpleTabbedView.wrapComponentTab(JourneyTableWell, {
                tabName: null,
                tabLabel: 'Journeys',
            }),
            props: () => ({
                ...listProps,
                hideAutoRefreshOptions: true,
            }),
        },
    ]

    return (
        <div className="journey-list">
            <PageHeader
                title="Journeys"
                onTitleSet={appService.customizeTabTitle}
                action={
                    <CurrentUserCan
                        do={AbilityAction.CREATE}
                        on={appState.abilityStore.getDomainOwnedIdentityFor(SubjectEntity.CAMPAIGN)}
                    >
                        <Button
                            className="new-notification-button"
                            type="primary"
                            altHref={newJourneyPath}
                            onClick={() => appService.route(newJourneyPath)}
                        >
                            <span>Create Journey</span>
                        </Button>
                    </CurrentUserCan>
                }
            />

            <SimpleTabbedView pathStyle="slash" animated={false} tabs={journeyTabs} />
        </div>
    )
}

export default Journeys
